export default function removeAllHTMLTags(text) {
  // Remove all HTML tags
  let cleaned = text.replace(/<[^>]+>/g, '');

  // Optional: Trim extra spaces/newlines (if needed)
  cleaned = cleaned.replace(/\s+/g, ' ').trim();

  return cleaned;
}